import { z } from 'zod';

import { PaymentDueId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const WaiveDelinquentInterestEvent = BaseLoanEvent.extend({
  type: z.literal('waiveDelinquentInterest'),
  paymentDueId: PaymentDueId,
});

export type WaiveDelinquentInterestEvent = z.infer<typeof WaiveDelinquentInterestEvent>;
